<template>
  <custom-modal modal-width="29rem" header-padding="10px 0px" inner-padding="6px 14px" @close="closeModal">
    <template #header>
      <div class="series__header">
        <span>Series</span>
        <i class="series__header--cancel icon-close" @click="closeModal"></i>
      </div>
      <hr />
    </template>

    <template #body>
      <form @submit.prevent="submit">
        <div class="series__body">
          <div class="series__body--right">
            <div class="form-group series__body--seriesIn">
              <fieldset>
                <legend>Series in</legend>
                <div class="series__body--field">
                  <span>
                    <input id="rows" ref="rowField" v-model="seriesIn" type="radio" name="seriesIn" value="Rows" />
                    <label for="rows"><u>R</u>ows</label>
                  </span>
                  <span>
                    <input
                      id="columns"
                      ref="columnField"
                      v-model="seriesIn"
                      type="radio"
                      name="seriesIn"
                      value="Columns"
                    />
                    <label for="columns"><u>C</u>olumns</label>
                  </span>
                </div>
              </fieldset>
            </div>

            <div class="form-group series__body--type">
              <fieldset>
                <legend>Type</legend>
                <div class="series__body--field">
                  <span>
                    <input id="linear" ref="linearField" v-model="type" type="radio" name="type" value="Linear" />
                    <label for="linear"><u>L</u>inear</label><br />
                  </span>
                  <span>
                    <input id="growth" ref="growthField" v-model="type" type="radio" name="type" value="Growth" />
                    <label for="growth"><u>G</u>rowth</label><br />
                  </span>
                  <span>
                    <input id="date" ref="dateField" v-model="type" type="radio" name="type" value="Date" />
                    <label for="date"><u>D</u>ate</label><br />
                  </span>
                  <span>
                    <input id="autofill" ref="autoField" v-model="type" type="radio" name="type" value="AutoFill" />
                    <label for="autofill">Auto<u>F</u>ill</label>
                  </span>
                </div>
              </fieldset>
            </div>

            <div class="form-group series__body--date">
              <fieldset>
                <legend>Date unit</legend>
                <div class="series__body--field">
                  <span
                    ><input
                      id="day"
                      ref="dayField"
                      v-model="dateUnit"
                      :disabled="type != 'Date'"
                      type="radio"
                      name="dateUnit"
                      value="Day" />
                    <label for="day">D<u>a</u>y</label><br
                  /></span>
                  <span>
                    <input
                      id="weekday"
                      ref="weekDayField"
                      v-model="dateUnit"
                      :disabled="type != 'Date'"
                      type="radio"
                      name="dateUnit"
                      value="Weekday"
                    />
                    <label for="weekday"><u>W</u>eekday</label><br />
                  </span>
                  <span>
                    <input
                      id="month"
                      ref="monthField"
                      v-model="dateUnit"
                      :disabled="type != 'Date'"
                      type="radio"
                      name="dateUnit"
                      value="Month"
                    />
                    <label for="month"><u>M</u>onth</label><br />
                  </span>
                  <span>
                    <input
                      id="year"
                      ref="yearField"
                      v-model="dateUnit"
                      :disabled="type != 'Date'"
                      type="radio"
                      name="dateUnit"
                      value="Year"
                    />
                    <label for="year"><u>Y</u>ear</label>
                  </span>
                </div>
              </fieldset>
            </div>
          </div>

          <div class="series__body--left">
            <div class="series__stepstop--step">
              <span>
                <label for="stepValue"><u>S</u>tep value</label>
                <input
                  id="stepValue"
                  ref="stepField"
                  v-model="stepValue"
                  :disabled="type == 'AutoFill'"
                  type="number"
                />
              </span>
            </div>

            <div class="series__stepstop--stop">
              <span>
                <label for="stopValue">St<u>o</u>p value</label>
                <input
                  id="stopValue"
                  ref="stopField"
                  v-model="stopValue"
                  type="number"
                  :disabled="type == 'AutoFill'"
                />
              </span>
              <div class="series__trend">
                <label for="trend"><u>T</u>rend</label>
                <input id="trend" ref="trendField" v-model="trend" type="checkbox" />
              </div>
            </div>

            <div class="series__btns">
              <custom-button button-class="btn btn-default btn-primary" button-type="submit"> OK </custom-button>
              <custom-button button-class="btn btn-default" button-type="button" @click="closeModal">
                {{ $t("actions.cancel") }}</custom-button
              >
            </div>
          </div>
        </div>
      </form>
    </template>
    <template #footer>
      <span></span>
    </template>
  </custom-modal>
</template>

<script>
import hotkeys from "hotkeys-js";
import CustomButton from "../../commons/CustomButton.vue";
import CustomModal from "../../commons/CustomModal.vue";
import DesignerMixin from "../DesignerMixin";
import { HotkeyScopes } from "../../../utils/constants";
import { defaultHotkyesFilterFunction } from "../cell/Utils";

export default {
  components: { CustomModal, CustomButton },
  mixins: [DesignerMixin],
  data() {
    return {
      seriesIn: "Rows",
      type: "Linear",
      dateUnit: "Day",
      trend: false,
      stepValue: 1,
      stopValue: undefined,
      prevScope: null,
    };
  },

  mounted() {
    // Adding a small delay to ensure the scope is set correctly
    setTimeout(() => {
      // Auto focus for setp input field when series popup is loaded.
      this.$refs.stepField.focus();
      hotkeys.filter = function (event) {
        return true; // Allow hotkeys even in input fields
      };
      this.prevScope = hotkeys.getScope();
      this.$store.dispatch("setScope", HotkeyScopes.SeriesBox);
      hotkeys("c,r,l,g,d,f,a,w,m,y,s,o,t,escape", HotkeyScopes.SeriesBox, (event, handler) => {
        event.preventDefault();
        switch (handler.key) {
          case "c":
            this.$refs.columnField.focus();
            this.seriesIn = "Columns";
            break;
          case "r":
            this.$refs.rowField.focus();
            this.seriesIn = "Rows";
            break;
          case "l":
            this.type = "Linear";
            this.$refs.linearField.focus();
            break;
          case "g":
            this.type = "Growth";
            this.$refs.growthField.focus();
            break;
          case "d":
            this.type = "Date";
            this.$refs.dateField.focus();
            break;
          case "f":
            this.type = "AutoFill";
            this.$refs.autoField.focus();
            break;
          case "a":
            this.dateUnit = "Day";
            this.$refs.dayField.focus();
            break;
          case "w":
            this.dateUnit = "Weekday";
            this.$refs.weekDayField.focus();
            break;
          case "m":
            this.dateUnit = "Month";
            this.$refs.monthField.focus();
            break;
          case "y":
            this.dateUnit = "Year";
            this.$refs.yearField.focus();
            break;
          case "t":
            this.trend = !this.trend;
            this.$refs.trendField.focus();
            break;
          case "s":
            this.$refs.stepField.focus();
            break;
          case "o":
            this.$refs.stopField.focus();
            break;
          case "escape":
            this.closeModal();
            break;
        }
      });
    }, 100); // 100ms delay
  },

  beforeUnmount() {
    hotkeys.filter = defaultHotkyesFilterFunction;
    this.$store.dispatch("setScope", this.prevScope);
    hotkeys.unbind("c,r,l,g,d,f,a,w,m,y,s,o,t,escape", HotkeyScopes.SeriesBox);
  },

  methods: {
    closeModal() {
      this.$store.dispatch("views/setSeriesDialogVisibility", false);
    },

    submit() {
      this.$store.dispatch("cells/fillSeries", {
        range: this.mainRange?.range,
        seriesIn: this.seriesIn,
        type: this.type,
        dateUnit: this.dateUnit,
        trend: this.trend,
        stepValue: this.stepValue,
        stopValue: this.stopValue,
      });
      this.closeModal();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables";

label,
input {
  cursor: pointer;
}

hr {
  margin-top: 5px;
  border: 1px solid #0832770f;
}

legend {
  color: @kk-primary-btn-bg-color;
}

fieldset {
  padding: 5px 12px 12px 12px;
  border: 2px solid #dbe1eb;
  border-radius: 5px;
  background: #08327705;
}

.series {
  &__header {
    font-size: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &--cancel {
      cursor: pointer;
      color: @kk-color-primary-blue;
    }
  }

  &__btns,
  &__stepstop--stop,
  &__body--right,
  &__body--left,
  &__trend,
  &__stepstop--stop span,
  &__stepstop--step span {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }

  &__body {
    display: grid;
    grid-template-columns: 1.5fr 1fr;
    gap: 2rem;

    &--right {
      align-items: normal;
    }

    &--left {
      justify-content: space-between;

      input {
        border-radius: 3px;
      }
      label {
        color: @kk-primary-btn-bg-color;
      }
    }

    &--field {
      margin-left: 10px;
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(75px, 1fr));
      gap: 5px;
      color: @kk-color-primary-blue;

      span {
        display: flex;
        align-items: center;

        input {
          accent-color: @kk-color-primary-blue;
          margin-right: 0.3rem;
        }
      }
    }
  }

  &__trend {
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    input {
      transform: scale(1.4);
      accent-color: @kk-color-primary-blue;
    }
  }

  &__stepstop--step,
  &__stepstop--stop {
    width: 65%;
    span {
      align-items: start;
      gap: 0px;

      input {
        border: 1px solid #dbe1eb;
        width: 100%;
        padding-left: 5px;
      }
    }
  }
}

.series {
  &__btns {
    gap: 7px;
    align-items: stretch;
    color: #fff;
    width: 100%;
    button[type="button"] {
      color: @kk-color-primary-blue;
      background: #c4cedd4d;
    }
  }
}
</style>
